module.exports = __webpack_public_path__ + "assets/images/pdf-feature@3x-3ba0cc9898ea1647b8a121b023b9a6c5.png";